import { Alert, Button, Stack, Text } from "@mantine/core";
import { ClockIcon } from "@heroicons/react/24/outline";

interface OutdatedDataAlertProps {
  expiredCount: number;
  totalCount: number;
  onRefresh: () => void;
}

export function OutdatedDataAlert({
  expiredCount,
  totalCount,
  onRefresh,
}: OutdatedDataAlertProps) {
  return (
    <Alert
      variant="default"
      title="Din översikt behöver uppdateras"
      icon={<ClockIcon width="20px" aria-hidden="true" />}
    >
      <Stack gap="md">
        <Text size="sm">
          {expiredCount === totalCount
            ? "Uppgifterna i din pensionsöversikt är äldre än 6 månader. Hämta nya uppgifter för att få en uppdaterad vy."
            : `Uppgifterna för ${expiredCount} av dina pensioner är äldre än 6 månader. Hämta nya uppgifter för att få en aktuell översikt.`}
        </Text>
        <Button fullWidth onClick={onRefresh}>
          Hämta nya uppgifter
        </Button>
      </Stack>
    </Alert>
  );
}
